


import React from 'react';
import Styles from "../../../scss/orderHistory.module.scss"
import { useTranslation } from 'react-i18next';
import { IDialogChildComponent } from '../../../reducers/dialog';
import { useOrderBacklog } from '../hooks/useOrderBacklog';
import { Skeleton } from '@material-ui/lab';

interface IFinishAllDialog extends IDialogChildComponent {

}

export default function ReadyAllDialog({
    onClose,
}: IFinishAllDialog) {
    const { t } = useTranslation();
    const { apiData, isLoading } = useOrderBacklog();

    return <div className={Styles.BacklogDialog}>
        <div className={Styles.BacklogData}>
            {isLoading ? <Skeleton variant="circle" /> : <p>{apiData ? apiData : 0}</p>}
        </div>
        <div>
            {t('orderHistory.modal.backlogTitle')}
        </div>
        <p>
            {t('orderHistory.modal.backlogInfo')}
        </p>
    </div>

}